// Skin preference for the single `skin` localStorage key.
// "light" is today's semi-dark look (dark menu, light content), not Vuexy's
// borderless light menu. "system" follows prefers-color-scheme.

export const SKIN_STORAGE_KEY = 'skin'

export const SKIN_CLASSES = ['dark-layout', 'bordered-layout', 'semi-dark-layout']

export const THEME_CHROME = {
  // Light stays the original browser-chrome value. Dark is the card surface.
  light: '#000000',
  dark: '#161e30'
}

export const normalizePreference = value => {
  if (value === 'dark' || value === 'system' || value === 'bordered') return value
  if (value === 'light' || value === 'semi-dark') return 'light'
  return 'system'
}

export const readStoredPreference = (raw, fallback = 'system') => {
  if (raw === null || raw === undefined || raw === '') return normalizePreference(fallback)
  try {
    return normalizePreference(JSON.parse(raw))
  } catch (error) {
    return normalizePreference(fallback)
  }
}

export const resolveSkin = (preference, prefersDark) => {
  if (preference === 'dark') return 'dark'
  if (preference === 'bordered') return 'bordered'
  if (preference === 'light') return 'semi-dark'
  return prefersDark ? 'dark' : 'semi-dark'
}

export const classForSkin = resolved => {
  if (resolved === 'dark') return 'dark-layout'
  if (resolved === 'bordered') return 'bordered-layout'
  if (resolved === 'semi-dark') return 'semi-dark-layout'
  return null
}

// Only the skin classes. Callers such as modals add their own body classes
// (`modal-open`) and this used to wipe those.
export const applySkinClass = (element, resolved) => {
  if (!element || !element.classList) return
  SKIN_CLASSES.forEach(cls => element.classList.remove(cls))
  const next = classForSkin(resolved)
  if (next) element.classList.add(next)
}

export const themeColorFor = resolved =>
  resolved === 'dark' ? THEME_CHROME.dark : THEME_CHROME.light
